import type { QueryKey } from '@tanstack/query-core';

import type { Feature } from '@luna/gatekeeper';
import { isFeatureEnabled } from '@luna/gatekeeper';

import { getQueryClient } from '../queryClientSingleton';

// disable retry after 2 fails => results in max 3 requests
export const MAX_FAILS_BEFORE_RETRY_IS_DISABLED = 2;
export const MAX_ERRORS = 3;
export const MIN_STATUS_CODE = 500;
export const MAX_STATUS_CODE = 599;

export const createRetryHandler =
    (cancelable?: boolean) =>
    (failureCount: number, error: any): boolean => {
        if (cancelable) {
            return failureCount < MAX_FAILS_BEFORE_RETRY_IS_DISABLED;
        }

        const shouldRetry = isFeatureEnabled<{ retry5XXRequests: Feature }>(
            (f) => f?.retry5XXRequests ?? false,
        );

        if (!shouldRetry) {
            return false;
        }

        const statusCode = error.statusCode ?? error.status;

        if (statusCode >= MIN_STATUS_CODE && statusCode <= MAX_STATUS_CODE) {
            return failureCount < MAX_FAILS_BEFORE_RETRY_IS_DISABLED;
        }

        return false;
    };

export function getRetryOnMountInCaseOfError(queryKey: QueryKey): boolean {
    const client = getQueryClient();
    const state = client.getQueryState(queryKey);

    return Math.max(state?.fetchFailureCount ?? 0, state?.errorUpdateCount ?? 0) < MAX_ERRORS;
}
